var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtpDecoration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 362,
    height: 231,
    viewBox: "0 0 362 231",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2868_54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.602 191.411C324.213 178.922 351.875 131.01 339.385 84.3986C326.896 37.7868 278.985 10.1252 232.373 22.6148C185.761 35.1044 158.099 83.0156 170.589 129.627C183.079 176.239 230.99 203.901 277.602 191.411Z",
    fill: "#4884E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3428 122.051L235.171 83.5122",
    stroke: "#03295F",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.676 144.811L260.504 106.272",
    stroke: "#03295F",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.186 177.45L250.014 138.911",
    stroke: "#03295F",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4912 215.078C121.671 206.456 140.768 173.379 132.145 141.2C123.523 109.02 90.446 89.9231 58.2664 98.5457C26.0867 107.168 6.98992 140.245 15.6124 172.424C24.2349 204.604 57.3116 223.701 89.4912 215.078Z",
    fill: "#4884E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2868_54"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 362,
    height: 231,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtpDecoration);
export default __webpack_public_path__ + "static/media/otp-decoration.0ce8d2fef48b66f5311300b2811e3c3a.svg";
export { ForwardRef as ReactComponent };